import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'

import {
  Container,
  Segment,
  Dimmer,
  Loader,
  Menu,
  Icon
} from 'semantic-ui-react'

import {
  getPageData
} from '_utils'

import Pagination from '_views/pagination'
import { PluralSearch as SerialsSearch } from '_forms/serialSearch'

import SerialItem from './serial'
import AddSerialModal from './addSerial'
import useCanAdminLicenses from '../../hooks/useCanAdminLicenses'

const displayNone = {display: 'none'}
const SerialsPage = props => {
  const {
    items,
    request,
    total,
    pageNum,
    perPage,
    autocomplete
  } = getPageData([], props.serialsPage)

  const canAdminLicenses = useCanAdminLicenses();

  return (
    <Container textAlign='left' fluid style={props.display ? {} : displayNone} >
      <Menu icon='labeled' secondary size='small'>
        <Menu.Menu position='left'>
          <Menu.Item fitted header style={{ maxWidth: "100%" }}>
            <SerialsSearch
              placeholder='Search serials...'
              autocomplete={autocomplete}
              onTermChange={props.onTermChange}
              onSelectionChange={props.onSelectionChange}
              onClearSuggestions={props.onClearSuggestions}
            />
          </Menu.Item>
        </Menu.Menu>
        <Menu.Menu position='right'>
          <Menu.Item name='refresh' onClick={() => props.onRefreshList(R.pathOr({}, ['navigation'], props.serialsPage)) } >
            <Icon name='refresh' />
            Refresh
          </Menu.Item>
          {
            canAdminLicenses ? <AddSerialModal onCreate={props.onCreateSerial} /> : null
          }
        </Menu.Menu>
      </Menu>

      <Pagination
        goToPage={props.goToPage}
        pageNum={pageNum}
        perPage={perPage}
        total={total}
      />
      <Segment.Group>
        <Dimmer inverted active={request.isLoading === true}>
          <Loader />
        </Dimmer>
        {items.map(u => <SerialItem
          key={u._id}

          onUnlinkSerial={props.onUnlinkSerial}
          onRefreshSerial={props.onRefreshSerial}
          onModifySerial={props.onModifySerial}
          setNavigation={props.setNavigation}

          serial={u}
          isLoading={request.isLoading === u._id}
        />) }
      </Segment.Group>
    </Container>
  )
}

SerialsPage.propTypes = {
  display: PropTypes.bool.isRequired,
  // mapStateToProps
  serialsPage: PropTypes.object.isRequired,
  // mapDispatchToProps
  onRefreshList: PropTypes.func.isRequired,
  onRefreshSerial: PropTypes.func.isRequired,
  onModifySerial: PropTypes.func.isRequired,
  onUnlinkSerial: PropTypes.func.isRequired,

  setNavigation: PropTypes.func.isRequired,
  goToPage: PropTypes.func.isRequired,

  onCreateSerial: PropTypes.func.isRequired,

  onTermChange: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  onClearSuggestions: PropTypes.func.isRequired
}

export default SerialsPage



// WEBPACK FOOTER //
// ./webAdmin/components/serials/page.js